import styled from "styled-components";
import { rgba } from "polished";

export const Wrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: 16px;
  user-select: none;
`;

export const Label = styled.div`
  display: block;
  width: 100%;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.2;
  color: ${props => rgba(props.theme.colors.text.default, 0.75)};
  text-transform: uppercase;
  letter-spacing: 0.0125em;
`;

export const Comp = styled.input`
  display: block;
  width: 100%;
  margin: 0;
  padding: 8px 12px;
  border: 0;
  border-radius: 0;
  outline: 0;
  font-size: 16px;
  line-height: 1.5;
  color: ${props => props.theme.colors.text.default};
  background-color: ${props => props.theme.colors.bg.default};
  border: 1px solid ${props => rgba(props.theme.colors.bg.reverse, 1 / 3)};
  appearance: none;
  transition: background-color 350ms ease-out;

  &:focus,
  &:active {
    border: 1px solid ${props => props.theme.colors.brand.blue};
  }
  &::placeholder {
    color: ${props => props.theme.colors.text.default};
    opacity: 0.5;
  }
`;
